class CSRTollbar extends Widget {
    constructor(element) {
        super(element);

        this.copy_link = this.element.querySelector('.tool-item.copy-link');
        this.send_link = this.element.querySelector('.tool-item.send-link');
        this.send_report = this.element.querySelector('.tool-item.send-report');

        // SMS routing is resolved by the backend/database.
        // Change only this base URL when promoting to ACCEPT/PROD.
        this.sms_api_base = 'https://j85mpgzp6c.execute-api.sa-east-1.amazonaws.com/accept';
        this.requires_employee_id = false;
        this.sms_route_loaded = false;
        this.sms_route_path = null;

        this.send_link_modal = document.createElement('div');
        this.send_link_modal.innerHTML = `
        <div class="mdn-Modal-content mdn-Modal--sm send-link">
            <div class="mdn-Modal-header">
            <h1 class="mdn-Heading mdn-Heading--xs ">${QelpCareHUB.translations.send_report_modal.title}</h1>
            <button aria-label="Button close modal" class="mdn-Button mdn-Button--icon mdn-Button--secondary mdn-Button--md mdn-Button-header-close " title="close"> <em class="mdn-Icon-fechar mdn-Icon--sm "></em><span></span></button>
            </div>
            <div class="mdn-Modal-body">
            <p class="mdn-Text mdn-Text--body mdn-Text--sm mdn-Text--bold device-name">
                ${QelpCareHUB.selected.device?.name || QelpCareHUB.selected.os?.name}
            </p>
            <p class="mdn-Text mdn-Text--body topic-name">
                ${QelpCareHUB.selected.usecase?.topicName}
            </p>
            <p class="mdn-Text mdn-Text--body mdn-Text--md mdn-Text--bold success">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M29.3334 18.6667H26.6667V9.65056L16.0958 19.1173L5.33341 9.62125V25.3333H18.6667V28H4.00008C3.26371 28 2.66675 27.4031 2.66675 26.6667V5.33333C2.66675 4.59696 3.26371 4 4.00008 4H28.0001C28.7365 4 29.3334 4.59696 29.3334 5.33333V18.6667ZM6.01536 6.66667L16.0826 15.5493L26.0014 6.66667H6.01536ZM25.3334 29.3333L20.6194 24.6193L22.505 22.7337L25.3334 25.5621L30.0474 20.848L31.933 22.7337L25.3334 29.3333Z" fill="#13982B"/>
                </svg>
                ${QelpCareHUB.translations.send_report_modal.success}
            </p>

            <div class="mdn-Input" data-employee-id-container style="display: none;">
                <input
                    id="employeeId"
                    title="employeeId"
                    type="text"
                    maxlength="40"
                    class="mdn-Input-field "
                    value=""
                />
                <label for="employeeId" aria-required="true" class="mdn-Input-label">${QelpCareHUB.translations.send_report_modal.employeeIdLabel}</label>
                <small class="mdn-Input-errorFeedback">
                    <span class="mdn-Icon-circulo-exclamacao mdn-Icon--sm" aria-label="circulo-exclamacao"></span> Por favor, preencha este campo corretamente.
                </small>
            </div>

            <div class="mdn-Input">
                <input data-mdn-type="phone" data-mdn-mask="(99) 9999 9999|(99) 9 9999 9999" id="sendLink" title="phone" type="tel" class="mdn-Input-field " value="" />
                <label for="sendLink" aria-required="true" class="mdn-Input-label">${QelpCareHUB.translations.send_report_modal.label}</label>
                <small class="mdn-Input-errorFeedback">
                    <span class="mdn-Icon-circulo-exclamacao mdn-Icon--sm" aria-label="circulo-exclamacao"></span> Por favor, preencha este campo corretamente.
                </small>
            </div>
            </div>
            <div class="mdn-Modal-footer">
            <div class="mdn-Modal-footer-start"></div>
            <div class="mdn-Modal-footer-end">
            <button class="mdn-Button mdn-Button--primary mdn-Button--md  ">${QelpCareHUB.translations.send_report_modal.send}</button>
            </div>
            </div>
        </div>
        `;

        this.send_link_modal.classList.add('mdn-Modal');
        this.send_link_modal_close = this.send_link_modal.querySelector('.mdn-Button-header-close');
        this.send_link_modal_primary = this.send_link_modal.querySelector('.mdn-Modal-footer .mdn-Button--primary');
        this.send_link_modal_employee_id = this.send_link_modal.querySelector('#employeeId');
        this.send_link_modal_employee_id_container =
            this.send_link_modal.querySelector('[data-employee-id-container]');
        this.send_link_modal_telephone = this.send_link_modal.querySelector('.mdn-Input #sendLink');

        try {
            this.textarea = document.createElement('textarea');
            this.textarea.style.position = 'absolute';
            this.textarea.style.top = '0px';
            this.textarea.style.left = '0px';
            this.textarea.style.width = '0px';
            this.textarea.style.height = '0px';
            this.textarea.value = QelpCareHUB.live + QelpCareHUB.uri;
        } catch (error) {
            console.warn(error);
            return;
        }

        this.copy_link.addEventListener('click', () => {
            this.textarea.focus();
            this.textarea.select();

            if (!navigator.clipboard) {
                document.execCommand('copy');
                console.log('URL copied with execCommand');
            } else {
                navigator.clipboard.writeText(this.textarea.value).then(() => {
                    console.log('URL copied with clipboard', this.textarea.value);
                });
            }

            this.copy_link.classList.add('copied');

            setTimeout(() => {
                this.copy_link.classList.remove('copied');
            }, 2000);
        });

        if (this.send_link_modal_employee_id) {
            this.send_link_modal_employee_id.addEventListener('keyup', e => {
                if (e.key === 'Enter') {
                    this.sendSMS();
                }
            });
        }

        this.send_link_modal_telephone.addEventListener('keyup', e => {
            if (e.key === 'Enter') {
                this.sendSMS();
            }
        });

        this.send_link_modal_primary.addEventListener('click', () => {
            this.sendSMS();
        });

        this.send_link.addEventListener('click', async () => {
            const routeReady = await this.loadSmsRoute();

            if (!routeReady) {
                window.alert('Não foi possível carregar a configuração de envio de SMS.');
                return;
            }

            this.send_link_modal.classList.add('mdn-is-open');
        });

        document.body.append(this.textarea);
        document.body.append(this.send_link_modal);
    }


    async loadSmsRoute() {
        const currentPath = window.location.pathname;

        if (
            this.sms_route_loaded &&
            this.sms_route_path === currentPath
        ) {
            return true;
        }

        try {
            const url =
                `${this.sms_api_base}/api-csr/route?path=${encodeURIComponent(currentPath)}`;

            const httpResponse = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!httpResponse.ok) {
                throw new Error(`SMS route HTTP ${httpResponse.status}`);
            }

            const response = await httpResponse.json();

            if (
                response.error ||
                !response.data ||
                typeof response.data.requiresEmployeeId !== 'boolean'
            ) {
                throw new Error('Invalid SMS route response');
            }

            this.requires_employee_id =
                response.data.requiresEmployeeId;

 	    if (this.send_link_modal_employee_id_container) {
	        this.send_link_modal_employee_id_container.style.display =
	            this.requires_employee_id ? '' : 'none';
	    }

            if (
                !this.requires_employee_id &&
                this.send_link_modal_employee_id
            ) {
                this.send_link_modal_employee_id.value = '';
            }

            this.sms_route_loaded = true;
            this.sms_route_path = currentPath;

            return true;
        } catch (error) {
            this.sms_route_loaded = false;
            this.sms_route_path = null;

            console.error('Unable to load SMS route:', error);
            return false;
        }
    }

    async sendSMS() {
        this.send_link_modal.classList.remove('warning', 'success');
        this.send_link_modal.classList.add('sending');

        const employeeId = this.send_link_modal_employee_id
            ? this.send_link_modal_employee_id.value.trim()
            : '';

        const telephone = this.send_link_modal_telephone.value.replace(/[^0-9]/g, '');

        const url = `${this.sms_api_base}/api-csr/send/sms`;

        if (
            telephone.length < 10 ||
            telephone.length > 11 ||
            (
                this.requires_employee_id &&
                (!employeeId || employeeId.length > 40)
            )
        ) {
            this.send_link_modal.classList.remove('sending');
            this.send_link_modal.classList.add('warning');
            return;
        }

        if (this.send_link_modal_employee_id) {
            this.send_link_modal_employee_id.setAttribute('disabled', 'disabled');
        }

        this.send_link_modal_telephone.setAttribute('disabled', 'disabled');
        this.send_link_modal_primary.setAttribute('disabled', 'disabled');

        // Browser sends only the relative pathname. No domain/query string.
        const data = {
            to: telephone,
            path: window.location.pathname
        };

        if (this.requires_employee_id) {
            data.employeeId = employeeId;
        }

        try {
            console.log('Sending SMS request:', {
                path: data.path,
                requiresEmployeeId: this.requires_employee_id
            });

            const httpResponse = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            const responseText = await httpResponse.text();
            let response = {};

            if (responseText) {
                try {
                    response = JSON.parse(responseText);
                } catch (parseError) {
                    console.error('Invalid JSON returned by SMS API');
                    throw new Error('A API de SMS retornou uma resposta inválida.');
                }
            }

            console.log('SMS API response:', httpResponse.status, {
                error: response.error,
                message: response.message
            });

            if (!httpResponse.ok) {
                throw new Error(
                    response.message ||
                    response.return ||
                    'Houve um erro ao enviar mensagem.'
                );
            }

            if (
                response.error === true ||
                response.error === 'true' ||
                response.success === false ||
                response.success === 2
            ) {
                throw new Error(
                    response.message ||
                    response.return ||
                    'Houve um erro ao enviar mensagem.'
                );
            }

            this.send_link_modal.classList.remove('sending', 'warning');
            this.send_link_modal.classList.add('success');

            setTimeout(() => {
                this.closeModal();
            }, 2000);
        } catch (error) {
            console.error('Erro ao enviar SMS:', error);

            this.send_link_modal.classList.remove('sending', 'success');
            this.send_link_modal.classList.add('warning');

            window.alert(
                error.message ||
                'Houve um erro ao enviar mensagem.'
            );

            if (this.send_link_modal_employee_id) {
                this.send_link_modal_employee_id.removeAttribute('disabled');
            }

            this.send_link_modal_telephone.removeAttribute('disabled');
            this.send_link_modal_primary.removeAttribute('disabled');
        }
    }

    closeModal() {
        this.send_link_modal.classList.remove('mdn-is-open', 'success', 'sending');

        if (this.send_link_modal_employee_id) {
            this.send_link_modal_employee_id.removeAttribute('disabled');
        }

        this.send_link_modal_telephone.removeAttribute('disabled');
        this.send_link_modal_primary.removeAttribute('disabled');
    }
}

window.addEventListener('eHelpFrameworkReady', () => {
    eHelpFramework.widgets.push(new CSRTollbar('.csr-toolbar'));
});
